<div *ngIf="ndg && surveyInfo" class="survey-heading">{{ 'survey.show.heading' | translate : { surveyId: surveyInfo.surveyId, fullName: ndg.name, ndg: ndg.ndg } }}</div>
<mat-tab-group *ngIf="ndg && surveyInfo">
    <div *ngIf="ndg.typology == 'FIS'">
        <!-- NDG DATA -->
        <mat-tab label="{{ 'survey.new.ndg-data.title' | translate }}">
            <ndg-data-fis [ndg]="ndg" [ndgData]="surveyInfo.ndgData"></ndg-data-fis>
        </mat-tab>

        <!-- NEEDS -->
        <mat-tab label="{{ 'survey.new.needs-fis.title' | translate }}">
            <needs-fis [needs]="surveyInfo.needsFis"></needs-fis>
        </mat-tab>

        <!-- PROTECTION -->
        <mat-tab label="{{ 'survey.new.protection.title' | translate }}" *ngIf="surveyNeedsEmit?.protection">
            <protection [protection]="surveyInfo.protection" [ndgData]="ndgDataEmit"></protection>
        </mat-tab>

        <!-- SAVINGS -->
        <mat-tab label="{{ 'survey.new.savings.title' | translate }}" *ngIf="surveyNeedsEmit?.savings">
            <savings [savings]="surveyInfo.savings" [surveyNeeds]="surveyNeedsEmit" [ndgData]="ndgDataEmit"></savings>
        </mat-tab>

        <!-- SAVINGS SHORT LIST -->
        <mat-tab label="{{ 'survey.new.savings-short-list.title' | translate }}" *ngIf="surveyNeedsEmit?.savings">
            <savings-short-list [shortList]="surveyInfo.shortList" [shortListProducts]="surveyInfo.shortListProducts"></savings-short-list>
        </mat-tab>

        <!-- PREVIDENCE -->
        <mat-tab label="{{ 'survey.new.previdence.title' | translate }}" *ngIf="!surveyNeedsEmit?.savings && surveyNeedsEmit?.previdence">
            <previdence [previdence]="surveyInfo.savings" [ndgData]="ndgDataEmit"></previdence>
        </mat-tab>
    
        <!-- REPORT -->
        <mat-tab label="{{ 'survey.show.report.title' | translate }}">
            <survey-show-report [ndg]="ndg" [survey]="surveyInfo" [surveyNeeds]="surveyNeedsEmit"></survey-show-report>
        </mat-tab>
    </div>

    <!-- GIURIDICAL PERSON -->
    <div *ngIf="ndg.typology == 'GIU'">
        <!-- NDG DATA -->
        <mat-tab label="{{ 'survey.new.ndg-data.title' | translate }}">
            <ndg-data-giu [ndg]="ndg" [ndgData]="surveyInfo.ndgData"></ndg-data-giu>
        </mat-tab>

        <!-- NEEDS -->
        <mat-tab label="{{ 'survey.new.needs-giu.title' | translate }}">
            <needs-giu [needs]="surveyInfo.needsGiu"></needs-giu>
        </mat-tab>

        <!-- SAVINGS -->
        <mat-tab label="{{ 'survey.new.savings.title' | translate }}" *ngIf="surveyNeedsEmit?.savings">
            <savings [savings]="surveyInfo.savings" [surveyNeeds]="surveyNeedsEmit" [ndgData]="ndgDataEmit"></savings>
        </mat-tab>

        <!-- SAVINGS SHORT LIST -->
        <mat-tab label="{{ 'survey.new.savings-short-list.title' | translate }}" *ngIf="surveyNeedsEmit?.savings && surveyInfo.shortList != null">
            <savings-short-list [shortList]="surveyInfo.shortList" [shortListProducts]="surveyInfo.shortListProducts"></savings-short-list>
        </mat-tab>
    
        <!-- REPORT -->
        <mat-tab label="{{ 'survey.show.report.title' | translate }}">
            <survey-show-report [ndg]="ndg" [survey]="surveyInfo" [surveyNeeds]="surveyNeedsEmit"></survey-show-report>
        </mat-tab>
    </div>
</mat-tab-group>
